import { ExplorerOptionProps } from "./ExplorerOption.types"
import "./ExplorerOption.css"

const ExplorerOption = (props: ExplorerOptionProps) => {

  const { explorerOption, isSelected, onClick } = props

  return (
    <div 
      className={`explorer-option-container ${isSelected ? "explorer-option-container-selected" : ""}`}
      onClick={() => onClick()}
    >
      <div className={isSelected ? "explorer-icon-selected" : "explorer-icon"}>{explorerOption.icon}</div>
      <p>{explorerOption.label}</p>
    </div>
  )
}

export default ExplorerOption